import * as React from "react";
import PropTypes from "prop-types";
import cs from "classnames";

import { Heading, baseRenderContentType } from "@lululemon/ui-library";
import { ErrorBoundary } from "@lululemon/mwa-logger";
import { renderContentfulComponent } from "@lululemon/cosy-contentful-renderer";

import { VisualStoryGridVideo } from "./visual-story-grid-video";
import { FeatureGrid } from "./feature-grid";
import { productEdHandleError } from "../../utils/product-education-logger";

import styles from "./visual-story-grid.module.scss";

function VisualStoryGrid({
  fallback,
  error,
  featureGrid,
  heading,
  heroMedia,
  text,
  videoRef
}) {
  React.useEffect(() => {
    if (error) {
      productEdHandleError(
        error,
        "Visual Story Grid Container",
        "Visual Story Grid",
        "useVisualStoryGridData"
      );
    }
  }, [error]);

  if (!heading) {
    return fallback;
  }

  const hasVideo = heroMedia?.sys?.contentType?.sys?.id === "video";

  return (
    <ErrorBoundary
      onError={(error) =>
        productEdHandleError(
          error,
          "Visual Story Grid Container",
          "Visual Story Grid"
        )
      }
    >
      <div className={cs("wrapper", "OneLinkNoTx")}>
        <Heading tag="h2" className={cs("lll-text-xlarge", styles.heading)}>
          {heading}
        </Heading>
        {hasVideo ? (
          <VisualStoryGridVideo video={heroMedia?.fields} videoRef={videoRef} />
        ) : (
          renderContentfulComponent({
            contentfulComponent: heroMedia,
            options: { renderContentType: baseRenderContentType }
          })
        )}
        <div className={cs("lll-grid", styles.textWrapper)}>
          <p className={cs("lll-text-medium", styles.text)}>{text}</p>
        </div>
        <FeatureGrid featureGrid={featureGrid} />
      </div>
    </ErrorBoundary>
  );
}

VisualStoryGrid.displayName = "VisualStoryGrid";

VisualStoryGrid.propTypes = {
  fallback: PropTypes.node,
  error: PropTypes.string,
  featureGrid: FeatureGrid.propTypes.featureGrid,
  heading: PropTypes.string,
  heroMedia: PropTypes.shape({
    sys: PropTypes.shape({
      contentType: PropTypes.shape({
        sys: PropTypes.shape({
          id: PropTypes.string.isRequired
        })
      })
    }),
    fields: PropTypes.oneOfType([
      PropTypes.shape(VisualStoryGridVideo.propTypes),
      PropTypes.shape({
        description: PropTypes.string,
        imageUrl: PropTypes.string,
        mobileImageUrl: PropTypes.string,
        name: PropTypes.string
      })
    ]).isRequired
  }).isRequired,
  text: PropTypes.string.isRequired,
  videoRef: PropTypes.object
};

VisualStoryGrid.defaultProps = {};

export default VisualStoryGrid;
